// Opens a print window with a styled document body and triggers print.
export function printDocument(title, innerHtml) {
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>${title}</title>
    <style>
      *{font-family:Arial,Helvetica,sans-serif;color:#0f172a;box-sizing:border-box}
      body{padding:32px;margin:0}
      h1{font-size:20px;margin:0}
      .muted{color:#64748b;font-size:12px}
      .hr{border:0;border-top:1px solid #e2e8f0;margin:16px 0}
      table{width:100%;border-collapse:collapse;margin-top:8px}
      th,td{text-align:left;padding:8px;border-bottom:1px solid #e2e8f0;font-size:13px}
      th{background:#f8fafc;text-transform:uppercase;font-size:10px;letter-spacing:.05em;color:#64748b}
      .row{display:flex;justify-content:space-between;align-items:flex-start}
      .totals{margin-top:12px;margin-left:auto;width:280px}
      .totals div{display:flex;justify-content:space-between;padding:4px 0;font-size:13px}
      .grand{font-weight:bold;font-size:15px;border-top:1px solid #cbd5e1;margin-top:4px;padding-top:8px}
      .tag{display:inline-block;background:#eff6ff;color:#1e40af;border:1px solid #bfdbfe;border-radius:4px;padding:2px 8px;font-size:12px;margin:2px}
      .sec{margin-top:16px}.sec h3{font-size:12px;text-transform:uppercase;color:#64748b;letter-spacing:.05em;margin:0 0 4px}
    </style></head><body>${innerHtml}
    <script>window.onload=function(){window.print();}</script></body></html>`);
  w.document.close();
}
